import { NonNullableFormBuilder } from '@angular/forms';
import { inject } from '@angular/core';

export interface EmergencyContact {
  number: string;
  name?: string;
  relationship?: string;
}

export const createEmergencyContactFormGroup = (
  fb?: NonNullableFormBuilder,
) => {
  fb ??= inject(NonNullableFormBuilder);

  return fb.group({
    name: fb.control(''),
    relationship: fb.control(''),
    number: fb.control(''),
  });
};
